/**
 * Analyzer: Day Overtrading
 *
 * Flags rapid-fire clusters on the SAME account (multi-account risk
 * distribution isn't overtrading — it's diversification). Uses the
 * pre-computed cluster list on DayContext.time.clusters.
 *
 * Surfaces the worst cluster by P&L when total damage ≥ $50.
 */

import { CATEGORY, SEVERITY, makeObservation } from '../../types';
import { humanHour, CLUSTER_WINDOW_MIN } from '../../dayUtils';

export const key = 'dayOvertrading';
export const tier = 'free';

export const analyze = (ctx) => {
  const { day } = ctx;
  if (!day || !day.time || !Array.isArray(day.time.clusters) || day.time.clusters.length === 0) {
    return null;
  }

  // Worst cluster by P&L
  const worst = day.time.clusters.reduce((w, c) => c.pnl < w.pnl ? c : w);
  if (worst.pnl >= -50) return null;  // Only flag meaningful damage

  const hour = Math.floor(worst.startTime / 60);
  const min = worst.startTime % 60;
  const accLabel = worst.accountName ? ` on ${worst.accountName}` : '';

  return makeObservation({
    id: `${key}:${day.date}:${worst.startTime}:${worst.accountId}`,
    analyzer: key,
    scope: 'day',
    scopeId: day.date,
    severity: SEVERITY.WARNING,
    category: CATEGORY.EMOTIONAL,
    title: 'Overtrading cluster flagged',
    detail: `${worst.count} trades inside ${CLUSTER_WINDOW_MIN}min near ${humanHour(hour)}${min > 0 ? `:${String(min).padStart(2, '0')}` : ''}${accLabel} cost $${Math.abs(worst.pnl).toFixed(0)}.`,
    action: 'Set a hard 3-trades-per-15min ceiling. Slow down when frustration spikes.',
    evidence: worst,
    metric: { label: 'Cluster Loss', value: `-$${Math.abs(worst.pnl).toFixed(0)}`, unit: '' },
    confidence: 0.85,
    priority: 82
  });
};
